import * as d3 from "d3";
import ZoomAbstract from "./ZoomAbstract";

export default class ManualZoomGenerator extends ZoomAbstract {
    // Public:
    constructor(cParams) {
        super(cParams);
        this.saveParams(cParams);
        this.computeOrigin();
        // this.panToOrigin();
        this.__initZoomState();
    }

    compute() {
        this.createZoom();
        this.setScaleLimits();
        return this._func;
    }

    // Private:
    saveParams(cParams) {
        this._svg = cParams.svg;
        this._minZoomScale = cParams.minZoomScale;
    }

    createZoom() {
        let zoomFunc = this.createZoomFunction();
        let func = d3.zoom().on("zoom", zoomFunc);
        this._func = func;
    }

    createZoomFunction() {
        const elementId = this._elementId;
        let getCurrentState = () => this.getZoomState();
        let setZoomState = s => this.setZoomState(s);
        let getNewViewBox = s => this.getNewViewBox(s);
        let func = function() {
            let svg = d3.select("#" + elementId).select("svg");
            svg.interrupt();
            let transform = getCurrentState();
            let viewBox = getNewViewBox(transform);
            svg.attr("viewBox", viewBox);
            setZoomState(transform);
        };
        return func;
    }

    panToOrigin() {
        let svg = this._svg;
        const P = this._origin;
        const dx = this.makeZeroIfInvalid(P.x);
        const dy = this.makeZeroIfInvalid(P.y);
        let transform = d3.zoomIdentity.translate(dx, dy);
        svg.attr("transform", transform);
        this.setZoomState(transform);
    }

    __initZoomState() {
        let transform = d3.zoomIdentity;
        this.setZoomState(transform);
    }

    computeOrigin() {
        const elementId = this._elementId;
        const element = document.getElementById(elementId);
        const w = element.clientWidth;
        const h = element.clientHeight;
        const origin = {
            x: w / 2,
            y: h / 2,
        };
        this._origin = origin;
    }

    setScaleLimits() {
        const minScale = this._minZoomScale;
        const maxScale = 1;
        let zoom = this._func;
        zoom.scaleExtent([minScale, maxScale]);
    }
}
